"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AdAnalyticsVideoIndexWatchingRating {
    constructor({ until, rate }) {
        this.toJSON = () => ({
            until: this.until,
            rate: this.rate,
        });
        this.until = until;
        this.rate = rate;
    }
}
AdAnalyticsVideoIndexWatchingRating.fromJSON = (json) => {
    const { until, rate } = Object.assign({}, json);
    if (typeof until !== 'number')
        throw new Error('.until must be a number');
    if (typeof rate !== 'number')
        throw new Error('.rate must be a number');
    return new AdAnalyticsVideoIndexWatchingRating({
        until,
        rate,
    });
};
exports.default = AdAnalyticsVideoIndexWatchingRating;
